import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { CartaCreateDishProdSelectPage } from '../../carta-create/carta-create-dish-prod-select/carta-create-dish-prod-select';
import { CartaCreateSelectTypePage } from '../../carta-create/carta-create-select-type/carta-create-select-type';
import { CartaServices } from '../../services';


@Component({
  selector: 'page-carta-template-list',
  templateUrl: 'carta-template-list.html',
})
export class CartaTemplateListPage {

  @Input() carta_uid: any;
  logo_url: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public cartaServices: CartaServices) {
    this.logo_url = this.getImageUrl(this.globals.restaurant.logo);
  }

  getImageUrl($img_url) {
    if ($img_url != '') {
      $img_url = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/' + encodeURIComponent($img_url) + '?alt=media';
      return $img_url;
    } else {
      return '';
    }
  }

  activePage(number) {
    this.cartaServices.page_active = number;
    this.cartaServices.getIndexOfPage();
    this.cartaServices.cleanEdit();
  }

  previusPage() {
    if (this.cartaServices.page_active > 1) {
      this.cartaServices.page_active -= 1;
    }
    this.cartaServices.getIndexOfPage();
    this.cartaServices.cleanEdit();
  }

  nextPage(number) {
    if (this.cartaServices.page_active < number) {
      this.cartaServices.page_active += 1
    }
    this.cartaServices.getIndexOfPage();
    this.cartaServices.cleanEdit();
  }

  editElements(section, index) {
    //
    this.cartaServices.edit_section = section;
    this.cartaServices.edit_index = index;
    this.cartaServices.edit_elements_array = this.globals.objectToArray(this.cartaServices.edit_section.elements);
    this.cartaServices.edit_type = 'element';
    //
    this.cartaServices.getIndexOfPage();
    this.navCtrl.push(CartaCreateDishProdSelectPage, {
      update_state: true,
      carta_uid: this.carta_uid,
      section_index: this.cartaServices.edit_index,
      page_index: this.cartaServices.edit_page_index,
      section_complete: this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections,
      section_name: this.cartaServices.edit_section.name,
      section_name_ca: this.cartaServices.edit_section.name_ca,
      section_name_en: this.cartaServices.edit_section.name_en,
      section_name_it: this.cartaServices.edit_section.name_it,
      section_name_fr: this.cartaServices.edit_section.name_fr,
      section_name_de: this.cartaServices.edit_section.name_de,
      new_section: false,
    });
  }

  editHeader(carta_name, type) {
    this.navCtrl.push(CartaCreateSelectTypePage, {
      update_state: true,
      carta_uid: this.carta_uid,
      carta_name: carta_name,
      type: type,
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/carta/carta-templates/carta-template-list/carta-template-list.ts